module.exports = __webpack_public_path__ + "static/img/14000264.75bce778.png";